import React, {
  useEffect, useCallback, useRef, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import CalendarToday from '@material-ui/icons/CalendarToday';
import moment from 'moment';

import getFormError from './getFormError';
import CustomSelect from '../../../../../../components/CustomInput/CustomSelect';
import { datesObjType, fieldType, formType } from './types';

const getOptions = dates => Object.keys(dates).map(v => ({
  text : moment(v).format('DD/MM/YYYY'),
  value: v,
}));

const DateSelector = ({
  field, form, dates, label, remoteError, 'data-testid': dataTestId,
}) => {
  const lastOptionRef = useRef();
  const options = useMemo(
    () => getOptions(dates),
    [dates],
  );
  // When the options change, we must reset the selected value in formik.
  // If there is only 1 option, we set it as the default value
  const updateField = useCallback(
    (value) => {
      form.setFieldValue(field.name, value, true);
      lastOptionRef.current = value;
    },
    [field.name, form],
  );
  const cleanOption = options.length === 1 ? options[0].value : '';
  useEffect(
    () => {
      if (lastOptionRef.current !== cleanOption) {
        updateField(cleanOption);
      }
    },
    [cleanOption, updateField],
  );
  const error = remoteError || getFormError(form, field.name);
  const disabled = !options.length;
  return (
    <CustomSelect
      data-testid={dataTestId}
      error={Boolean(error)}
      helpText={error}
      id={field.name}
      labelText={label}
      formControlProps={{ fullWidth: true }}
      inputProps={{
        ...field,
        disabled,
      }}
      IconComponent={CalendarToday}
      options={options}
    />
  );
};

DateSelector.defaultProps = {
  'data-testid': undefined,
  remoteError  : undefined,
};

DateSelector.propTypes = {
  'data-testid': PropTypes.string,
  field        : fieldType.isRequired,
  form         : formType.isRequired,
  dates        : datesObjType.isRequired,
  label        : PropTypes.string.isRequired,
  remoteError  : PropTypes.string,
};

export default DateSelector;
